import React from 'react';
import { styled } from '@linaria/react';

import IconColorMode from '@/components/Icons/IconColorMode';
import IconSpeaker from '@/components/Icons/IconSpeaker';
import Checkbox from '@/components/Checkbox';

import DemoLikeButton from './DemoLikeButton';

const SoundExamplesFromBlog = () => {
  const [checkboxValue, setCheckboxValue] = React.useState(true);

  return (
    <Wrapper>
      <ToggleWrapper>
        <IconColorMode size={32} />
      </ToggleWrapper>
      <ToggleWrapper>
        <IconSpeaker size={32} />
      </ToggleWrapper>
      <ToggleWrapper>
        <DemoLikeButton />
      </ToggleWrapper>
      <ToggleWrapper>
        <Checkbox
          size={25}
          checked={checkboxValue}
          onChange={() => setCheckboxValue(!checkboxValue)}
        />
      </ToggleWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 128px);
  grid-gap: 32px;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 64px;
`;

const ToggleWrapper = styled.div`
  display: grid;
  place-content: center;
  height: 128px;
  border-radius: 4px;
  outline: 1px solid var(--color-content-outline);

  html[data-color-mode='light'] & {
    box-shadow:
      -2px 0px 10px rgba(0, 0, 0, 0.05),
      0 0.3px 0.3px rgba(0, 0, 0, 0.002),
      0 0.7px 0.7px rgba(0, 0, 0, 0.004),
      0 1.3px 1.4px rgba(0, 0, 0, 0.009),
      0 2.2px 2.5px rgba(0, 0, 0, 0.015),
      0 4.2px 4.6px rgba(0, 0, 0, 0.024),
      0 10px 11px rgba(0, 0, 0, 0.04);
  }
`;

export default SoundExamplesFromBlog;
